import React, { Component } from 'react';
import './SubNavbar.css';
import './EmailAddresses.css';
import { post, get } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
// import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import { Button} from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import Select from 'react-select';
import moment from 'moment-timezone';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class EmailAddresses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // emails: "",
      defaultEmailSaved: false, // Track if default email is saved
      emails: [], // 1 default email inputs
      error: "",
      success: false,
      error2: false,
      error1 :false,
      warning : false,
      success_report : false,
      warning_report : false,
      open_progress_bar: false,
      selectedDays : [],
      selectedTime: "09:00",
      blur_detection: 5,
      tilt_detection: 5,
      block_detection: 5,
      selectedTimezone: null, // default timezone
      defaultEmail:'',
      storedLogo: localStorage.getItem("USER_LOGO") || null,

    };
  }

  componentDidMount() {
    this.fetchUserSettings();
    //----------not getting used anymore ------------------
    //  const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    // const storedUserEmail = localStorage.getItem(globalVariables.USER_EMAIL);

    // this.setState({
    //   user_type: storedUserType,
    //   defaultEmail: storedUserEmail || "",
    // }, () => {
    //   console.log("Set from global variable: ", this.state.defaultEmail);
    // });
    //-----------------------------------------------------
    // this.getDealerInfo();

  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.error !== prevState.error ||
        this.state.error1 !== prevState.error1 ||
        this.state.success !== prevState.success ||
        this.state.warning !== prevState.warning ||
        this.state.warning_report !== prevState.warning_report ||
        this.state.success_report !== prevState.success_report
    ) {
        if (
            this.state.error ||
            this.state.error1 ||
            this.state.success ||
            this.state.warning ||
            this.state.warning_report ||
            this.state.success_report
        ) {
            setTimeout(() => {
                this.setState({
                    error: false,
                    success:false,
                    error1: false,
                    warning : false,
                    success_report : false,
                    warning_report : false,
                });
            }, 3000); // 3 second
        }
    }
}

  validateEmails = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };


  handleDefaultEmailChange = (event) => {
    this.setState({ defaultEmail: event.target.value });
  };

  handleInputChange = (index, value) => {
    // const input = e.target.value;
    // this.setState({ emails: input });

    // if (input && !this.validateEmails(input)) {
    //   this.setState({ error: "Invalid email format. Use comma-separated emails." });
    // } else {
    //   this.setState({ error: "" });
    // }
    const emails = [...this.state.emails];
    emails[index] = value;
    this.setState({ emails });

    // Validate the individual email
    if (value && !this.validateEmails(value)) {
      this.setState({ error: `Invalid email format at position ${index + 1}.` });
    } else {
      this.setState({ error: "" });
    }
  };

  fetchUserSettings = async () => {
    console.log("--------EmailAddress tab---------" );
    const weekdayOptions = [
  { value: 'Sunday', label: 'Sunday' },
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' }
];

    try {
      this.startLoading();
      let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_token}`
      }

      const response = await get(urls.NOTIFICATION_SETTINGS_LIST, headers);

      this.stopLoading();
      if (response && Array.isArray(response) && response.length > 0 && response[0].email_addresses !== undefined) {
  const emailString = response[0].email_addresses || "";
        const emailArray = emailString ? emailString.split(",").map(email => email.trim()) : [""];
        // Ensure the first email is set as defaultEmail
        const scheduleTimeString = response[0].schedule_email_time || "09:00";

        // Expecting format like "09:00,America/New_York", as the timzone value is added in the same variable and separated by a comma
        // Split the time and timezone parts
        const [timePart, timezonePart] = scheduleTimeString.split(',');

        const timeString = timePart?.trim() || "09:00";
        const timezoneString = timezonePart?.trim() || "America/New_York"; // Default fallback



      const daysArray = response[0].schedule_days_of_week
        ? response[0].schedule_days_of_week.split(',').map(day => day.trim())
        : [];

      const selectedDaysFormatted = weekdayOptions.filter(opt => daysArray.includes(opt.value));

        this.setState({
          // defaultEmail: emailArray.length > 0 ? emailArray[0] : this.state.defaultEmail, now the default email field is removed from UI
          emails: emailArray, // all emails go into the emails array
          selectedDays: selectedDaysFormatted,
          selectedTime: timeString,
          selectedTimezone: timezoneString,
          blur_detection: response[0].detection_settings?.blur_detection ?? 5,
          tilt_detection: response[0].detection_settings?.tilt_detection ?? 5,
          block_detection: response[0].detection_settings?.block_detection ?? 5,

          });
      }
    } catch (error) {
      console.error("Error fetching user settings:", error);
      // this.setState({error1:true});
    }
  };

  jsonData = () => {
    const { defaultEmail, emails } = this.state;

    // Ensure defaultEmail is at 0th index and concatenate with other emails
  let emailList = [defaultEmail.trim(), ...emails.filter(email => email.trim())];

  // // Remove duplicates while keeping defaultEmail at index 0
  // emailList = [...new Set(emailList)];

    let data = {
        "email_addresses": emailList.join(","),
    }
    return JSON.stringify(data)
  }


//   getDealerInfo = async () => {
//   try {
//     let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
//     let dealer_uuid = localStorage.getItem(globalVariables.USER_ID);

//     let headers = {
//       'content-type': 'application/json',
//       'Authorization': `Bearer ${access_token}`
//     };

//     const response = await get(`${urls.BASE_URL}/api/users/dealer_user/${dealer_uuid}/`, headers);
//     if (response?.data?.[0]?.dealer_email) {
//       this.setState({ defaultEmail: response.data[0].dealer_email }, () => {
//         console.log("Set from dealer API:", this.state.defaultEmail);
//       });
//     }
//   } catch (error) {
//     console.error("getDealerInfo failed:", error);
//   }
// };

  handleSave = async () => {
    const { defaultEmail, emails } = this.state;
    console.log("email to save------", emails.length);

    // Check if defaultEmail is empty or invalid
    // if (!defaultEmail.trim() || !this.validateEmails(defaultEmail.trim())) {
    //   this.setState({ warning: true, error: "Please enter a valid default email." });
    //   return;
    // }

    //  Check if any email is empty or invalid --> modified the condition below to allow blank custom field while saving as it was not allowing to update other info. if any custom field kept blank
    for (let i = 0; i < emails.length; i++) {
      const email = emails[i].trim();
      if (email && !this.validateEmails(email)) { //skip validation when the optional email field is blank
        this.setState({ warning: true, error: `Invalid or empty email at position ${i + 1}.` });
        return;
      }
    }

    // Remove empty optional email fields
    const filteredEmails = emails
      .map(email => email.trim())
      .filter(email => email !== "");

     // Update UI to remove empty inputs
    this.setState({ emails: filteredEmails });

    // Combine all valid emails
    const emailList = [defaultEmail.trim(), ...filteredEmails];

    let post_data = {
      schedule_days_of_week: this.state.selectedDays.map(day => day.label).join(","),
      email_addresses: emailList.join(","),
      schedule_email_time: `${this.state.selectedTime},${this.state.selectedTimezone}`,
      detection_settings: {
        blur_detection: parseInt(this.state.blur_detection),
        tilt_detection: parseInt(this.state.tilt_detection),
        block_detection: parseInt(this.state.block_detection)
    }
    };

    post_data= JSON.stringify(post_data);
    console.log("post data===>", post_data);

    this.startLoading();

    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    };

    let response = await post(urls.NOTIFICATION_SETTINGS_CREATE, post_data, headers);
    console.log("handleSave response===>", response);
    this.stopLoading();

    if(response?.email_addresses?.[0]?.includes("Duplicate email in request:")){
      this.setState({warning_report: true});
    } else if (response !== false) {
      this.setState({ success: true, defaultEmailSaved: true });
    }
     else {
      this.setState({ error2: true });
    }
  };


  handleDemoReport = () => {
    const { emails } = this.state;

    if (this.validateEmails(emails)) {
      // alert(`Sending demo report to: ${emails}`);
      this.setState({success_report: true});
    } else {
      // alert("Please enter valid email(s) to send the report.");
      this.setState({warning_report: true})
    }
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true})
  }

  stopLoading = () => {
      this.setState({ open_progress_bar: false})
  }

  addEmailField = () => {
    this.setState((prevState) => ({
      emails: [...prevState.emails, ""],
    }));
  };

  // removeEmailField = (index) => {
  //   this.setState((prevState) => {
  //     const emails = [...prevState.emails];
  //     emails.splice(index, 1); // remove the email at the given index
  //     return { emails };
  //   });
  // };

  removeEmailField = (index) => {
  this.setState((prevState) => {
    const emails = [...prevState.emails];
    emails.splice(index, 1);

    return {
      emails: emails.length > 0 ? emails : [""]
    };
  });
};

  handleChange = (selectedOptions) => {
    this.setState(selectedOptions || []);
  };


  render() {
    const { emails, error, error2, success_report, warning_report, success, error1, warning, selectedDays } = this.state;
    const weekdayOptions = [
      { value: 'Monday', label: 'Monday' },
      { value: 'Tuesday', label: 'Tuesday' },
      { value: 'Wednesday', label: 'Wednesday' },
      { value: 'Thursday', label: 'Thursday' },
      { value: 'Friday', label: 'Friday' },
      { value: 'Saturday', label: 'Saturday' },
      { value: 'Sunday', label: 'Sunday' },
    ];

    const timezoneOptions = moment.tz.names().map(tz => ({
      value: tz,
      label: tz.replace(/_/g, ' ')
    }));



    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <div className="email-addresses-page" style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="side-by-side-container email-addresses-layout" style={{ flex: '2', marginLeft:'10%', padding: '20px', overflowY: 'auto', gap:'20px', width:'90%' }}>
            <div className="health-setting-container email-addresses-settings" style={{width:'50%'}}>
              <div style={{ width:'100%'}}>
                  { error2 ? (
                              <Alert severity="error">Error saving emails. Please try again.!</Alert>
                          ) : success ? (
                              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                  "Settings saved successfully."
                            </Alert>
                          ) : success_report ? (
                            <Alert severity="error">
                                "Sending demo report to: ${emails}"
                            </Alert>
                          ) : warning_report ? (
                            <Alert severity="warning">
                                "Duplicate email address entered."
                            </Alert>
                            ) : error1 ? (
                              <Alert severity="error">
                                  "Server Error occured while fetching user email..."
                              </Alert>
                          ) : success_report ? (
                            <Alert severity="error">
                                "Sending demo report to: ${emails}"
                            </Alert>
                            ) : warning_report ? (
                              <Alert severity="error">
                                  "Please enter valid email(s) to send the report."
                              </Alert>
                              ) : error1 ? (
                                <Alert severity="error">
                                    "Server Error occured while fetching user email..."
                                </Alert>
                                ) : warning ? (
                                  <Alert severity="error">
                                      "No emails provided. Email not saved."
                                  </Alert>
                                  ) : null}
              </div>
              <div className="email-addresses-card" style={{
                backgroundColor: "#353d4f",
                 padding: '5px', width:'100%'}}>
                <h3>Scheduled times for email delivery</h3>
                <span className="email-schedule-controls" style={{ display: "flex", flexDirection: "row", gap:'5px', alignItems: "center",  width:'100%' }}>
                  <select
                    className="input-email"
                    aria-label="Email delivery time"
                    value={this.state.selectedTime}
                    onChange={(evt) => this.setState({ selectedTime: evt.target.value })}
                    style={{ width: "50%", marginBottom: '5px', backgroundColor: "#313746",color: "#fff", }}
                  >
                    {Array.from({ length: 24 }, (_, i) => {
                      const hour24 = i.toString().padStart(2, '0');
                      const hour12 = (i % 12 === 0 ? 12 : i % 12).toString().padStart(2, '0');
                      const ampm = i < 12 ? 'AM' : 'PM';
                      return (
                        <option key={hour24} value={`${hour24}:00`}>
                          {hour12}:00 {ampm}
                        </option>
                      );
                    })}
                  </select>
                  <Select
                    name="timezone"
                    aria-label="Email delivery timezone"
                    options={timezoneOptions}
                    // value={timezoneOptions.find(tz => tz.value === this.state.selectedTimezone)}
                    value={
                      this.state.selectedTimezone
                        ? timezoneOptions.find(tz => tz.value === this.state.selectedTimezone)  //conditioned to show placeholder when no option is selected.
                        : null
                    }
                    onChange={(selected) => this.setState({ selectedTimezone: selected?.value || null })}
                    className="basic-single email-timezone-select"
                    classNamePrefix="select"
                    placeholder="Select Timezone"
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: '50%',
                        marginBottom: '5px',
                        fontSize: '14px',

                      }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "#313746",
                        borderColor: state.isFocused ? "#888" : "#444",
                        boxShadow: "none",
                      }),
                      menu: (base) => ({
                        ...base,
                        backgroundColor: "#313746",
                        color: "#fff",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused
                          ? "#3a3f4b"
                          : state.isSelected
                          ? "#5c6bc0"
                          : "#313746",
                        color: "#fff",
                        cursor: "pointer",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "#fff",
                      }),
                    }}
                  />
                </span>
                <Select
                  isMulti
                  name="weekdays"
                  aria-label="Email delivery days"
                  options={weekdayOptions}
                  placeholder="Select days"
                  className="basic-multi-select"
                  // style={{ width: "92%", fontSize: '14px' }}
                  styles={{
                      container: (base) => ({
                        ...base,
                        width: '100%',
                        fontSize: '14px',
                      }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "#313746",
                        borderColor: state.isFocused ? "#888" : "#444",
                        boxShadow: "none",
                      }),
                      menu: (base) => ({
                        ...base,
                        backgroundColor: "#313746",
                        color: "#fff",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused
                          ? "#3a3f4b"
                          : state.isSelected
                          ? "#5c6bc0"
                          : "#313746",
                        color: "#fff",
                        cursor: "pointer",
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#3a3a3a",
                        color: "#fff",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: "#fff",
                      }),
                    }}
                  classNamePrefix="select"
                  onChange={(selectedOptions) => {
                    const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
                    this.setState({ selectedDays: optionsArray });
                  }}
                  value={selectedDays}
                />

                <h3>Email addresses</h3>
                {/* <input
                  type="email"
                  className="input-email"
                  value={this.state.defaultEmail}
                  onChange={this.handleDefaultEmailChange}
                  placeholder="Enter default email"
                  // readOnly={this.state.defaultEmailSaved && this.state.user_type !== "DealerUser"} // Readonly logic
                  readOnly // Readonly logic temporarily showing the logged in users email, waiting for feedback on this workflow
                  style={{ width: "95%", backgroundColor: "#313746", color: "#fff",}}
                /> */}
                <div className="email-addresses-list" style={{ overflowY:'scroll', maxHeight: "200px" }}>
                    {this.state.emails.map((email, index) => (
                      <div className="email-address-row" key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px", justifyContent:"center", marginTop:'5px' }}>
                        {/* <div style={{ display: "flex", flexDirection:'row', marginTop:'5px', width: '100%'}}> */}
                          <input
                            key={index}
                            type="email"
                            className="input-email"
                            value={email}
                            onChange={(e) => this.handleInputChange(index, e.target.value)}
                            placeholder={`Enter email ${index + 1}`}
                            aria-label={`Email address ${index + 1}`}
                            style={{
                            display: "block", width: "100%", backgroundColor: "#313746", color: "#fff",}}
                          />

                          <button
                            type="button"
                            onClick={() => this.removeEmailField(index)}
                            id="clearUserLogButton"
                            className="email-remove-button"
                            aria-label={`Remove email ${index + 1}`}
                            style={{
                              minWidth: "25px",
                              height: "31px",

                            }}
                          >
                            -
                          </button>
                        {/* </div> */}
                      </div>
                    ))}

                </div>
                  {error && <p style={{ color: "red", fontSize: "12px" }}>{error}</p>}

                  <div className="email-address-actions" style={{display:"flex", justifyContent: "center"}}>
                    <Button
                      type="button"
                      onClick={this.addEmailField}
                      id="rowsPerPageButton"
                      style={{
                        minWidth:"25px",
                        // height:"34px",
                        marginTop:'6px'
                      }}
                    >
                      + Add
                    </Button>
                    <span className="email-save-action"
                      style={{
                        cursor:
                          this.state.emails.length === 0 ||
                          this.state.emails.every(email => !email.trim())
                            ? 'not-allowed'
                            : 'pointer',
                      }}
                    >
                    <Button id="rowsPerPageButton"
                      style={{
                        marginTop:'9px',
                      }}
                      onClick={this.handleSave}
                      disabled={this.state.emails.length === 0 || this.state.emails.every(email => !email.trim())} // Disable button when no email addresses are specified
                      > Save
                    </Button>
                    </span>
                  </div>
              </div>
            </div>
            <div className="email-addresses-help" style={{width:'50%'}}>
              <div className="form-section" style={{fontFamily: "Arial, sans-serif", width:'100%'}} >


                  <h4>How it works?</h4>
                  <p style={{ fontSize: "15px", marginBottom: "7px", textAlign: "justify" }}>
                    <span style={{color:'lightseagreen'}}>Schedule times for email delivery</span> <br/><br/>
                    Please specify the time to receive an email report with detailed information about each of the devices in your account. You can schedule daily or weekly emails.
                    <br />
                    <strong>-</strong> If you select only time, the email will be sent daily at the specified time.<br />
                    <strong>-</strong> If you select time along with multiple days, the email will be sent on all selected days at the specified time.

                  </p>

                  <p style={{ fontSize: "15px", marginBottom: "7px", textAlign: "justify" }}>
                    <span style={{color:'lightseagreen'}}>Email addresses</span> <br/><br/>
                    <strong>-</strong>Please specify the email address(es) to receive this report. If you want
                    to send emails to multiple addresses, please click on '+' button to add new block and type only one email in each.
                    <strong>-</strong> If no email is specified then by default, the report will be sent to the email address registered in the user's profile.
                  </p>
              </div>
            </div>
          </div>
          {/* Backdrop with Circular Progress */}
          <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
                <div className="circle"></div>
                <div className="circle tilted"></div>
                <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
            </div>
          </Backdrop>
        </div>
      </ThemeProvider>
    );
  }
}

export default EmailAddresses;
